module.exports = __webpack_public_path__ + "img/NO.fda4c69a.png";